"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireWildcard(require("../base/component"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var secondsOfOneDay = 86400;
var nameOfDays = ['日', '一', '二', '三', '四', '五', '六'];
var nameOfMonths = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];
var todayDate = new Date();

var getEndDateOfMonth = function getEndDateOfMonth(year, month) {
  var nextMonth = new Date(year, month + 1, 1);
  return new Date(nextMonth.getTime() - secondsOfOneDay).getDate();
};

var getWeekIndex = function getWeekIndex(year, month, date) {
  // 获取当前日期的周信息，信息模板为weekData
  var weekData = {
    year: year,
    week: 1,
    weekMonday: ''
  };
  var firstDateOfyear = new Date(year, 0, 1);
  var selectTime = new Date(year, month, date);
  var firstMonTimeOfyear = firstDateOfyear.getTime() - ((firstDateOfyear.getDay() > 0 ? firstDateOfyear.getDay() : 7) - 1) * secondsOfOneDay * 1000;
  var thisWeekMondayTime = new Date(selectTime.getTime() - ((selectTime.getDay() > 0 ? selectTime.getDay() : 7) - 1) * secondsOfOneDay * 1000);
  weekData.week = parseInt(String((selectTime.getTime() - firstMonTimeOfyear) / (secondsOfOneDay * 7 * 1000)), 10) + 1;
  weekData.weekMonday = "".concat(thisWeekMondayTime.getFullYear(), "-").concat(thisWeekMondayTime.getMonth() + 1, "-").concat(thisWeekMondayTime.getDate());

  if (month === 11 && date >= 25) {
    // 最后一个月的几天不满一周为下一年的第一周
    var selectTimeDay = selectTime.getDay() > 0 ? selectTime.getDay() - 1 : 6;

    if (date - 25 !== selectTimeDay) {
      weekData.year = year + 1;
      weekData.week = 1;
      return weekData;
    }
  }

  return weekData;
};

var checkToday = function checkToday(year, month, date) {
  return year === todayDate.getFullYear() && month === todayDate.getMonth() && date === todayDate.getDate();
};

var DateButton = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(DateButton, _KZUIComponent);

  var _super = _createSuper(DateButton);

  function DateButton(props) {
    var _this;

    _classCallCheck(this, DateButton);

    _this = _super.call(this, props);
    _this.state = {
      selected: _this.props.selected,
      included: _this.props.included,
      index: _this.props.index
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateButton, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        selected: nextProps.selected,
        included: nextProps.included,
        index: nextProps.index
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (this.props.className !== '') {
        this.props.onClick(this.props.date);
        this.setState({
          selected: !this.state.selected
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var clsPrefix = 'kui-date-picker';
      var _this$props$date = this.props.date,
          year = _this$props$date.year,
          month = _this$props$date.month,
          date = _this$props$date.date;
      var className = this.props.className;
      var _this$state = this.state,
          selected = _this$state.selected,
          included = _this$state.included;
      var cls = ["".concat(clsPrefix, "-date-button"), "".concat(clsPrefix, "-").concat(className)];

      if (checkToday(year, month, date)) {
        cls.push("".concat(clsPrefix, "-today"));
      }

      var clspadding = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, cls.join('-selected '), selected && className !== ''), _defineProperty(_classNames, cls.join('-included '), included && className !== ''), _defineProperty(_classNames, cls.join('-legal '), className !== ''), _classNames), className);
      var clsicon = (0, _classnames["default"])(_defineProperty({}, cls.join('-includedcon '), included && className !== ''), cls.join(' '));
      return /*#__PURE__*/React.createElement("div", {
        className: clsicon,
        onClick: this.handleClick,
        onMouseOver: function onMouseOver() {
          if (_this2.props.className !== '') {
            var _this2$props$onMouseO, _this2$props;

            (_this2$props$onMouseO = (_this2$props = _this2.props).onMouseOver) === null || _this2$props$onMouseO === void 0 ? void 0 : _this2$props$onMouseO.call(_this2$props, _this2.state.index);
          } else {
            var _this2$props$onMouseO2, _this2$props2;

            (_this2$props$onMouseO2 = (_this2$props2 = _this2.props).onMouseOver) === null || _this2$props$onMouseO2 === void 0 ? void 0 : _this2$props$onMouseO2.call(_this2$props2, 32);
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: clspadding
      }, this.props.children));
    }
  }]);

  return DateButton;
}(_component["default"]); // DateButton.defaultProps = {
//     className: '',
//     onClick: null,
// };
// DateButton.propTypes = {
//     className: PropTypes.string,
//     onClick: PropTypes.func,
//     date: PropTypes.shape({
//         year: PropTypes.number.isRequired,
//         month: PropTypes.number.isRequired,
//         date: PropTypes.number.isRequired,
//     }).isRequired,
//     children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
// };


_defineProperty(DateButton, "defaultProps", _objectSpread(_objectSpread({}, _component.baseDefaultProps), {}, {
  className: '',
  onClick: null
}));

var DatePanel = /*#__PURE__*/function (_KZUIComponent2) {
  _inherits(DatePanel, _KZUIComponent2);

  var _super2 = _createSuper(DatePanel);

  function DatePanel(props) {
    var _this3;

    _classCallCheck(this, DatePanel);

    _this3 = _super2.call(this, props);

    _this3.autoBind('handleDateSelect', 'handleYearIncrease', 'handleYearDecrease', 'handleMonthIncrease', 'handleMonthDecrease', 'handleOver', 'handleOut');

    var date = props.value ? new Date(props.value) : todayDate;
    var dataAno = props.valueAno ? new Date(props.valueAno) : todayDate;
    _this3.state = {
      year: date.getFullYear(),
      month: date.getMonth(),
      date: date.getDate(),
      monthAno: dataAno.getMonth(),
      yearAno: dataAno.getFullYear(),
      hoverArr: props.hoverArr,
      minDate: new Date(props.minDate),
      maxDate: new Date(props.maxDate),
      indexArr: typeof props.index !== 'undefined' ? props.index.sort() : null,
      indexOther: props.indexOther
    };
    return _this3;
  }

  _createClass(DatePanel, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(nextState === this.state);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var date = nextProps.value ? new Date(nextProps.value) : todayDate;
      var dataAno = nextProps.valueAno ? new Date(nextProps.valueAno) : todayDate;
      var hover = this.state.hoverArr;

      if (nextProps.refresh) {
        hover = [];
      }

      this.setState({
        year: date.getFullYear(),
        month: date.getMonth(),
        date: date.getDate(),
        indexArr: nextProps.index,
        indexOther: nextProps.indexOther,
        monthAno: dataAno.getMonth(),
        yearAno: dataAno.getFullYear(),
        hoverArr: hover
      });
    }
  }, {
    key: "handleDateSelect",
    value: function handleDateSelect(data) {
      var _this4 = this;

      var year = data.year,
          month = data.month,
          date = data.date,
          index = data.index;

      if (this.props.onChange) {
        this.props.onChange("".concat(year, "-").concat(month + 1, "-").concat(date), index);
      }

      this.setState({
        year: year,
        month: month,
        date: date
      }, function () {
        if (typeof _this4.state.indexArr === 'undefined' || _this4.state.indexArr === null) return;

        if (_this4.state.indexArr.length === 2 || _this4.state.indexArr.length === 1 && _this4.state.indexOther.length === 1) {
          var _this4$props$onCollap, _this4$props;

          (_this4$props$onCollap = (_this4$props = _this4.props).onCollapse) === null || _this4$props$onCollap === void 0 ? void 0 : _this4$props$onCollap.call(_this4$props);
        }
      });
    }
  }, {
    key: "handleOver",
    value: function handleOver(index) {
      var _this$state2 = this.state,
          indexArr = _this$state2.indexArr,
          indexOther = _this$state2.indexOther;
      if (typeof indexArr === 'undefined' || indexArr === null) return; //  if we already chosen two buttons, nothing to do

      if (indexArr.length === 2) return; //  else we need to update hover array

      var hover = [];

      if (indexArr.length === 0 && indexOther.length === 1) {
        /*  if we already chose on date from another panel but not chose any button on myself
              we should hover all the datebtn from index to the end or from start to index.
              if we are in 1st panel => hover from index+1 to the end
              if we are in 2nd panel => hover from 1 to index */
        if (this.props.pos === 1) {
          hover[0] = index + 1;
          hover[1] = 32;
        } else {
          hover[0] = 1;
          hover[1] = index;
        }
      } else if (index > indexArr[0]) {
        /*  if we have chosen one button in this panel,
              update hover arr depends on the newer hover one's pos   */
        hover[0] = indexArr[0] + 1;
        hover[1] = index;
      } else {
        hover[0] = index + 1;
        hover[1] = indexArr[0];
      }

      this.setState({
        hoverArr: hover
      });
    }
    /*  if already have chosen on button in this panel and we move out,
      that means we want to chose another datebtn in another panel,
      we need to hover all the left datebtn in this panel */

  }, {
    key: "handleOut",
    value: function handleOut() {
      var _this$state3 = this.state,
          indexArr = _this$state3.indexArr,
          indexOther = _this$state3.indexOther;
      var hover = [];
      if (typeof indexArr === 'undefined' || indexArr === null) return;

      if (indexArr.length === 1 && indexOther.length === 0) {
        if (this.props.pos === 1) {
          hover[0] = indexArr[0] + 1;
          hover[1] = 32;
        } else {
          hover[0] = 1;
          hover[1] = indexArr[0];
        }
      }

      this.setState({
        hoverArr: hover
      });
    }
  }, {
    key: "updateYear",
    value: function updateYear(year) {
      var _this5 = this;

      if (year >= this.state.minDate.getFullYear() && year <= this.state.maxDate.getFullYear()) {
        this.setState({
          year: year
        }, function () {
          var _this5$props$onPanelC, _this5$props;

          (_this5$props$onPanelC = (_this5$props = _this5.props).onPanelChange) === null || _this5$props$onPanelC === void 0 ? void 0 : _this5$props$onPanelC.call(_this5$props, _this5.state.year, _this5.state.month);
        });
      }
    }
  }, {
    key: "updateMonth",
    value: function updateMonth(month) {
      var _this6 = this;

      if (month > -1 && month < 12) {
        this.setState({
          month: month
        }, function () {
          var _this6$props$onPanelC, _this6$props;

          (_this6$props$onPanelC = (_this6$props = _this6.props).onPanelChange) === null || _this6$props$onPanelC === void 0 ? void 0 : _this6$props$onPanelC.call(_this6$props, _this6.state.year, _this6.state.month);
        });
      }
    }
  }, {
    key: "handleYearIncrease",
    value: function handleYearIncrease() {
      this.updateYear(this.state.year + 1);
    }
  }, {
    key: "handleYearDecrease",
    value: function handleYearDecrease() {
      this.updateYear(this.state.year - 1);
    }
  }, {
    key: "handleMonthIncrease",
    value: function handleMonthIncrease() {
      this.updateMonth(this.state.month + 1);
    }
  }, {
    key: "handleMonthDecrease",
    value: function handleMonthDecrease() {
      this.updateMonth(this.state.month - 1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var clsPrefix = 'kui-date-picker';
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          pos = _this$props.pos;
      var cls = (0, _classnames["default"])(clsPrefix, className);
      var _this$state4 = this.state,
          year = _this$state4.year,
          month = _this$state4.month,
          date = _this$state4.date,
          indexArr = _this$state4.indexArr,
          hoverArr = _this$state4.hoverArr,
          monthAno = _this$state4.monthAno,
          yearAno = _this$state4.yearAno; // const monthDif = Math.abs(monthAno - month);
      // const yearDif = Math.abs(yearAno - year);
      // const clsHide1 = classNames({ [`${clsPrefix}--hidden`]: monthDif <= 1 && yearDif <= 0 && pos === 1 });
      // const clsHide2 = classNames({ [`${clsPrefix}--hidden`]: monthDif <= 1 && yearDif <= 0 && pos === 2 });
      // const clsyearHide1 = classNames({ [`${clsPrefix}--hidden`]: (yearDif < 1 || (yearDif === 1 && month >= monthAno)) && pos === 1 });
      // const clsyearHide2 = classNames({ [`${clsPrefix}--hidden`]: (yearDif < 1 || (yearDif === 1 && month <= monthAno)) && pos === 2 });

      var firstDay = new Date(year, month, 1).getDay();
      var endDate = getEndDateOfMonth(year, month);
      var list = []; // prev month

      if (firstDay !== 0) {
        var prevMonthYear = month > 0 ? year : year - 1;
        var prevMonth = month > 0 ? month - 1 : 11;
        var endDateOfPrevMonth = getEndDateOfMonth(prevMonthYear, prevMonth);

        for (var i = firstDay; i > 0; i -= 1) {
          var idate = endDateOfPrevMonth - (i - 1);
          list.push({
            year: prevMonthYear,
            month: prevMonth,
            date: idate,
            text: idate,
            className: '',
            index: i
          });
        }
      } // cur month


      for (var _i = 1; _i <= endDate; _i += 1) {
        list.push({
          year: year,
          month: month,
          date: _i,
          text: _i,
          className: _i === date ? 'cur-month cur-date' : 'cur-month',
          index: _i
        });
      } // next month


      if (list.length < 42) {
        var nextMonthYear = month < 11 ? year : year + 1;
        var nextMonth = month < 11 ? month + 1 : 0;
        var nextMonthDays = 42 - list.length;

        for (var _i2 = 1; _i2 <= nextMonthDays; _i2 += 1) {
          list.push({
            year: nextMonthYear,
            month: nextMonth,
            date: _i2,
            text: _i2,
            className: '',
            index: _i2
          });
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style,
        onMouseOut: this.handleOut
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-left-controls")
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.handleYearDecrease
      }, "<<"), /*#__PURE__*/React.createElement("span", {
        onClick: this.handleMonthDecrease
      }, "<")), /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-current-month")
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-month")
      }, nameOfMonths[month]), /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-year")
      }, year)), /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-right-controls")
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.handleMonthIncrease
      }, ">"), /*#__PURE__*/React.createElement("span", {
        onClick: this.handleYearIncrease
      }, ">>"))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-title")
      }, nameOfDays.map(function (text, key) {
        return /*#__PURE__*/React.createElement("span", {
          className: "".concat(clsPrefix, "-day-title"),
          key: "title-".concat(key)
        }, text);
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-date-table")
      }, list.map(function (item, key) {
        return /*#__PURE__*/React.createElement(DateButton, {
          key: "date-".concat(key),
          className: item.className,
          date: item,
          index: item.index,
          onClick: _this7.handleDateSelect,
          onMouseOver: _this7.handleOver,
          selected: indexArr !== null && typeof indexArr !== 'undefined' && indexArr.indexOf(item.index) !== -1 && item.className !== '',
          included: hoverArr !== null && typeof hoverArr !== 'undefined' && item.index >= hoverArr[0] && item.index < hoverArr[1]
        }, item.text);
      })));
    }
  }]);

  return DatePanel;
}(_component["default"]);

_defineProperty(DatePanel, "defaultProps", _objectSpread(_objectSpread({}, _component.baseDefaultProps), {}, {
  value: null,
  minDate: '1970-1-1',
  maxDate: '2117-12-31'
}));

var _default = DatePanel;
exports["default"] = _default;